import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const contactService = {
  getAll,
  getOne,
  create,
  update,
  remove,
}

export function getAll(filter = {}) {
  const params = {}
  if (filter.debtorCode) params.debtor_code = filter.debtorCode
  if (filter.page) params.page = filter.page
  if (filter.size) params.size = filter.size
  if (filter.search) params.search = filter.search
  return apiHelper(API_URL).get('/contacts', { params })
}

export function getOne(uuid) {
  return apiHelper(API_URL).get(`/contacts/${uuid}`)
}

export function create(payload) {
  return apiHelper(API_URL).post('/contacts', payload)
}

export function update(uuid, payload) {
  return apiHelper(API_URL).put(`/contacts/${uuid}`, payload)
}

export function remove(uuid) {
  return apiHelper(API_URL).delete(`/contacts/${uuid}`)
}
